/**
 * contract-form.ts — Chuyển đổi form ↔ dữ liệu cho tab Gói & thanh toán (Platform):
 *  - Hợp đồng gói Doanh nghiệp (C2): ô trống = không giới hạn.
 *  - Điều chỉnh số lượng khi gia hạn tay (C3): ô trống = giữ nguyên số đang dùng.
 */
import type { ContractLimits, Quotas } from '@/hooks/use-platform-org-manage'

export const CONTRACT_FIELDS: Array<{ key: keyof ContractLimits; label: string }> = [
  { key: 'members', label: 'Nhân viên' },
  { key: 'officialChannels', label: 'Kênh chính thức' },
  { key: 'personalChannels', label: 'Tài khoản cá nhân' },
  { key: 'activeContactsPerMonth', label: 'Khách hoạt động / tháng' },
  { key: 'aiRepliesPerDay', label: 'Lượt AI trả lời / ngày' },
]

export const QUOTA_FIELDS: Array<{ key: keyof Quotas; label: string }> = CONTRACT_FIELDS.slice(0, 3) as Array<{ key: keyof Quotas; label: string }>

export type FormValues<K extends string> = Record<K, string>

const parseCount = (v: string): number | null | undefined => {
  const t = v.trim()
  if (!t) return null
  const n = Number(t)
  return Number.isInteger(n) && n >= 0 ? n : undefined
}

export function contractToForm(c: ContractLimits | null): FormValues<keyof ContractLimits> {
  const out = {} as FormValues<keyof ContractLimits>
  for (const f of CONTRACT_FIELDS) out[f.key] = c?.[f.key] == null ? '' : String(c[f.key])
  return out
}

/** Form → hợp đồng. null khi có ô không hợp lệ (số âm / thập phân / chữ). */
export function contractFromForm(v: FormValues<keyof ContractLimits>): ContractLimits | null {
  const out = {} as ContractLimits
  for (const f of CONTRACT_FIELDS) {
    const n = parseCount(v[f.key] ?? '')
    if (n === undefined) return null
    out[f.key] = n
  }
  return out
}

/**
 * Form điều chỉnh số lượng gia hạn → phần gửi lên API. Ô trống bỏ qua; không ô nào → undefined (chép y gói).
 * `invalid` = có ô sai định dạng.
 */
export function quantityAdjust(v: Partial<FormValues<keyof Quotas>>): { quantities?: Partial<Quotas>; invalid: boolean } {
  const out: Partial<Quotas> = {}
  for (const f of QUOTA_FIELDS) {
    const n = parseCount(v[f.key] ?? '')
    if (n === undefined) return { invalid: true }
    if (n !== null) out[f.key] = n
  }
  return { quantities: Object.keys(out).length ? out : undefined, invalid: false }
}
